import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = {role: ROLE.CENTER};
const path = "center/patient"

export const UpdateAppointment = async (value, role) => {
    return await axiosInstance(role ? {role} : options).post(`${path}/update-appointment`, value);
}

export const list = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
}

export const add = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
}

export const edit = async (values) => {
  return await axiosInstance(options).put(`${path}/edit`, values);
}

export const deletePatient = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete?o_id=${values.o_id}`);
}

export const detail = async (values) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${values.o_id}`, values);
}

export const changeStatus = async (values) => {
  return await axiosInstance(options).patch(`${path}/change-status`, values);
}

export const editHealth = async (values) => {
  return await axiosInstance(options).put(`${path}/update-health-matrix`, values);
}

export const sendOTP = async (values) => {
  return await axiosInstance(options).post(`${path}/send-patient-history-otp`, values);
}

export const verifyOTP = async (values) => {
  return await axiosInstance(options).post(`${path}/list-patient-history`, values);
}
export const addAppointments = async (values) => {
  return await axiosInstance(options).post(`${path}/create-appointment`, values);
}
export const listAppointments = async (values) => {
  return await axiosInstance(options).post(`${path}/list-appointment`, values);
}
export const editAppointments = async (values) => {
  return await axiosInstance(options).post(`${path}/update-appointment`, values);
}
export const getAppointments = async (values) => {
  return await axiosInstance(options).post(`${path}/get-appointment`, values);
}